import { IViewModel } from '../../interfaces/view-model.interface';

export abstract class Milestone implements IViewModel {
    // Constants.
    public static readonly Action_SetWorkflowState: string = "SetWorkflowState";

    // Define primitive properties.
    // Key.
    public id: number = 0;

    public name: string;

    public description: string;

    public milestoneType: string;

    public action: string;
    public automaticallyPerformAction: boolean = true;

    public targetDate: Date;
    //public targetTimeDisplayValue: string;
    public hoursOffset: number;

    public sendNotification: boolean;
    public notificationTemplateName: string;

    // Abstract method(s).
    public abstract get MilestoneType(): string; // e.g. 'Site'
    public abstract get Description(): string;
}
